var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKarmaPoint = function SvgKarmaPoint(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8899 6.77188C13.628 8.78538 15.2147 10.372 17.2282 11.1101L18.7743 11.6768C19.0752 11.7872 19.0752 12.2129 18.7743 12.3232L17.279 12.8713C15.2333 13.6212 13.6211 15.2333 12.8713 17.279L12.3232 18.7743C12.2129 19.0752 11.7872 19.0752 11.6768 18.7743L11.1287 17.279C10.3789 15.2333 8.76671 13.6212 6.721 12.8713L5.22575 12.3232C4.92475 12.2129 4.92475 11.7872 5.22575 11.6768L6.721 11.1287C8.76671 10.3789 10.3789 8.76677 11.1287 6.721L11.6768 5.22575C11.7872 4.92475 12.2129 4.92475 12.3232 5.22575L12.8899 6.77188Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKarmaPoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/karma-point.e67caeda145cc6d1b042d011c0bdbf2d.svg";